import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import {
  refinementList,
  hits,
  pagination,
  configure,
  clearRefinements,
} from "instantsearch.js/es/widgets";

/**
 * Employee Stories — year-only listing.
 *
 * A trimmed sibling of articleSearch.js: same Algolia/InstantSearch wiring, but
 * only the `year` refinement, and a distinct "stories card" hit template
 * (bordered box, blue title, excerpt, arrow). Selectors are namespaced
 * `js-stories-*` so it never collides with the newsroom search.
 */

export function employeeSearch($) {
  const $search = $(".js-stories-search");

  if ($search.length < 1) return;

  const algoliaIndexName = $search.data("index");
  const algoliaApplicationId = $search.data("application-id");
  const algoliaSearchKey = $search.data("search-key");

  if (!algoliaIndexName || !algoliaApplicationId || !algoliaSearchKey) return;

  const $clearRefinementsBox = $search.find(".js-stories-clear-filters");
  const $yearBox = $search.find(".js-stories-year");
  const $resultsBox = $search.find(".js-stories-results");
  const $paginationBox = $search.find(".js-stories-pagination");

  if (
    $clearRefinementsBox.length < 1 ||
    $yearBox.length < 1 ||
    $resultsBox.length < 1 ||
    $paginationBox.length < 1
  )
    return;

  const search = instantsearch({
    indexName: algoliaIndexName,
    routing: true,
    stalledSearchDelay: 200,
    searchClient: algoliasearch(algoliaApplicationId, algoliaSearchKey),
  });

  const arrowRight = `
    <span class="stories-card--arrow" aria-hidden="true">
      <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 12H30" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M21 4L30 12L21 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>`;

  const storiesCardTemplate = (item) => {
    return `
      <a class="stories-card d-flex flex-column js-card" href="${item.link}" ${item.linkTarget}>
        <div class="stories-card--image">
          <img src="${item.image}" alt="${item.imageAlt}" class="w-100" loading="lazy">
        </div>
        <div class="stories-card--content">
          <h3 class="stories-card--title">${item.title}</h3>
          <p class="stories-card--excerpt">${item.excerpt ?? ""}</p>
          ${arrowRight}
        </div>
      </a>
      `;
  };

  const refinementListClasses = {
    root: "search-filters--filters--refinement",
    list: "search-filters--filters--refinement--list d-flex flex-wrap",
    item: "search-filters--filters--refinement--item",
    selectedItem: "search-filters--filters--refinement--selected-item",
    label: "search-filters--filters--refinement--label",
    checkbox: "search-filters--filters--refinement--checkbox",
    labelText: "search-filters--filters--refinement--label-text label-text",
    count: "search-filters--filters--refinement--count",
  };

  search.addWidgets([
    configure({
      hitsPerPage: 9,
    }),
    clearRefinements({
      container: $clearRefinementsBox[0],
      templates: {
        resetLabel: "Clear all filters",
      },
    }),
    refinementList({
      container: $yearBox[0],
      attribute: "year",
      operator: "and",
      sortBy: ["name:desc"],
      cssClasses: refinementListClasses,
    }),
    hits({
      container: $resultsBox[0],
      templates: {
        item: storiesCardTemplate,
      },
      cssClasses: {
        root: "container",
        list: ["row stories-grid"],
        item: ["col-12 col-md-6 col-xl-4 stories-grid--column"],
      },
    }),
    pagination({
      container: $paginationBox[0],
      scrollTo: false,
      cssClasses: {
        root: "",
        list: "pagination d-flex align-items-center justify-content-center",
        item: "pagination--item",
        firstPageItem: "pagination--item--first icon page-first",
        lastPageItem: "pagination--item--last icon page-last",
        previousPageItem: "pagination--item--prev icon page-prev",
        nextPageItem: "pagination--item--next icon page-next ",
        pageItem: "pagination--item--number",
        selectedItem: "pagination--item--current",
        disabledItem: "d-none",
        link: "pagination--link d-flex align-items-center justify-content-center",
      },
    }),
  ]);

  search.start();
}
